import React from "react";
import Layout from "../components/layout";
import {Link} from "gatsby"
//import BlogRoll from "../components/BlogRoll";
import Head from "../components/head";
import Converter from "../components/apps/converter/converter";
import styled from "styled-components"
import Button from "../components/Button"
import { Router, } from "@reach/router"
const apps = [
  {name: "hexbindec",url:"/hexbindec",image:"assets/kevin-horvat-pyjp2zmxulk-unsplash.jpg"},
  {name: "caesar",url:"/caesar",image: "assets/damian-zaleski-ryyr-k3ysqg-unsplash.jpg"}
]

export default () => (
    <Layout>
        <Head title="toutes categories pense-betes" />
        <h1>Toutes les applications</h1>
          <section>
            <div className="content">
               <Wrapper>
                 {apps.map((app,index)=>{
                   return(
                    <TestWrapper key={`app-${index}`}> 
                      <Link to={app.url}>
                          <img src={app.image} alt="Avatar" style={{width:"100%"}}/>
                            <div className="container">
                                <h4><b>{app.name}</b></h4>
                                
                            </div>
                            
                      </Link>              
                            
                    </TestWrapper>
                   );
                 })}
                 </Wrapper> 
            </div>
          </section>
    </Layout>
)

const Wrapper = styled.div`
    margin: 0 auto;
    max-width: 1300px;
    display: grid;
   
    grid-template-columns: 1fr 1fr;
    grid-gap: 30px;
    @media screen and (max-width: 681px){
        grid-template-columns: 1fr ;
    }
`;

const TestWrapper = styled.div`
position: relative;
box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
transition: 0.3s;
width: 
&:hover{
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
border-radius: 5px;
img{
    border: solid orange;
    margin: 0;
    border-radius: 5px;
    width: 100%;
    height: 300px;
}
.container{
    h4{
        margin: 0;
    }
    padding: 2px 2px;
    //border: solid red;
}

`;